import { render, staticRenderFns } from "./ImgView.vue?vue&type=template&id=2c0e8b4e&scoped=true"
import script from "./ImgView.vue?vue&type=script&lang=js"
export * from "./ImgView.vue?vue&type=script&lang=js"
import style0 from "./ImgView.vue?vue&type=style&index=0&id=2c0e8b4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0e8b4e",
  null
  
)

export default component.exports